import { DecoderHelpers } from '@headless-workspace/utils';
import { z } from 'zod';
import { ProductStockDTO } from '../../types/ProductStockDTO';
import { TileProductDTO } from '../../types/TileProductDTO';

export const RecommendedTileProductDTO = TileProductDTO.extend({
    stock: ProductStockDTO.optional(),
    imageURL: z.string().optional(),
    trackingId: z.string().optional(),
});

export const RecommendedProductsDTO = z.object({
    id: z.string(),
    title: z.string().optional(),
    cta: z.object({
        label: z.string().optional(),
        link: z.string().optional(),
    }),
    products: z.array(RecommendedTileProductDTO),
});

export type RecommendedProductsDTO = z.infer<typeof RecommendedProductsDTO>;

export const RecommendedProductsWithUnknownDTO = z.object({
    recommendations: z.array(
        z
            .object({
                products: DecoderHelpers.defaultArray(z.unknown()),
            })
            .and(RecommendedProductsDTO.omit({ products: true })),
    ),
});
